module.exports = __webpack_public_path__ + "img/1-右.095a1c0b.svg";